// SliderSkeleton.tsx
import React from "react";
import "./SliderSkeleton.scss";

const SliderSkeleton = () => {
  return (
    <div className="slider-skeleton">
      <div className="image-skeleton"></div>
      <div className="slider-caption">
        <div className="title-skeleton"></div>
        <div className="title-skeleton"></div>
        <div className="desc-skeleton"></div>
        <div className="button-skeleton"></div>
      </div>
    </div>
  );
};

export default SliderSkeleton;
